import apiFetch from "../utils/fetch";

export function folderCreate(data, callback, errorcallback) {
    apiFetch('/api/folder', {
        method: 'POST',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderGetParentByUser(userName, callback, errorcallback) {
    apiFetch('/api/folder/user/' + userName + '/parent/').then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderGetByLevelByUser(userName, level, callback, errorcallback) {
    apiFetch('/api/folder/user/' + userName + '/level/' + level).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderGetByDashboardByUser(userName, dashboardID, callback, errorcallback) {
    apiFetch('/api/folder/user/' + userName + '/dashboard/' + dashboardID).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderEdit(data, callback, errorcallback) {
    apiFetch('/api/folder/edit/' + data._id, {
        method: 'PUT',
        body: JSON.stringify(data),
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderGet(id, callback, errorcallback) {
    apiFetch('/api/folder/' + id).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}

export function folderDelete(id, callback, errorcallback) {
    apiFetch('/api/folder/' + id._id, {
        method: 'DELETE',
    }).then(data => {
        if (callback != null) {
            callback(data);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}